import React from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';

import { Container, Button, Row, Col, Form, Spinner } from 'react-bootstrap';
import MaterialTable from 'material-table';
import { dateFormatUtil } from '../Utilities';
import Modal from 'react-bootstrap/Modal';
import EditRounded from '@material-ui/icons/EditRounded';
import Alert from 'react-bootstrap/Alert';

import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';

import RestServices from '../services/RestServices.js';
import ViewProfile from '../Profile/ViewProfile';
import ProfileTags from '../Profile/ProfileTags';
import ProfileChart from '../Profile/ProfileChart';
import OrdersList from '../Profile/OrdersList';
import ProfileWallet from '../Profile/ProfileWallet';
import MasterGiftCards from '../Profile/MasterGiftCards';
import VirtualAccounts from '../Profile/VirtualAccounts'
import GCStatement from '../Profile/GCStatement';
import DailyWalletSummary from '../Profile/DailyWalletReport';


class ViewProfileDetail extends React.Component {
    _isMounted = false;
    state = {};

    componentWillUnmount() {
        this._isMounted = false;
    }
    async componentDidMount() {
        this._isMounted = true;
    }

    render() {
        return (
            <Container className="no_padding">
                <div>
                    <hr />
                </div>
                <Row style={{ justifyContent: 'center' }}>
                    <h4 style={{ marginLeft: '1rem', marginRight: '1rem' }}>
                        {this.props.profileFullName} ({this.props.UniqeID})
                    </h4>
                </Row>
                <div>
                    <hr />
                </div>
                <Tabs
                    defaultActiveKey="editProfile"
                    id="uncontrolled-tab-example"
                >
                    <Tab eventKey="editProfile" title="Profile">
                        <div>
                            <hr />
                        </div>
                        <ViewProfile
                            selectedUserRole={this.props.selectedUserRole}
                            UniqeID={this.props.UniqeID}
                            {...this.props}
                        />
                    </Tab>
                    
                    {/*
                    <Tab eventKey="listStoretag" title="Store Tags">
                        <div>
                            <hr />
                        </div>
                        <ProfileTags
                            selectedUserRole={this.props.selectedUserRole}
                            UniqeID={this.props.UniqeID}
                            {...this.props}
                        />
                    </Tab>
                    <Tab eventKey="listOrders" title="Store Orders">
                        <div>
                            <hr />
                        </div>
                        <OrdersList
                            selectedUserRole={this.props.selectedUserRole}
                            UniqeID={this.props.UniqeID}
                            {...this.props}
                        />
                    </Tab>
                    <Tab eventKey="loadGraph" title="Load Graph">
                        <div>
                            <hr />
                        </div>
                        <ProfileChart
                            selectedUserRole={this.props.selectedUserRole}
                            UniqeID={this.props.UniqeID}
                            {...this.props}
                        />
                    </Tab>*/}

                    <Tab eventKey="MasterGiftCards" title="GC Management">
                        <div>
                            <hr />
                        </div>
                        <MasterGiftCards
                            selectedUserRole={this.props.selectedUserRole}
                            UniqeID={this.props.UniqeID}
                            {...this.props}
                        />
                    </Tab>

                    <Tab eventKey="GCStatement" title="GC Statement">
                        <div>
                            <hr />
                        </div>
                        <GCStatement
                            selectedUserRole={this.props.selectedUserRole}
                            UniqeID={this.props.UniqeID}
                            {...this.props}
                        />
                    </Tab>

                    {this.props.role !='GManager' &&<Tab eventKey="loadWithdraw" title="Wallet Management">
                        <div>
                            <hr />
                        </div>
                        <ProfileWallet
                            selectedUserRole={this.props.selectedUserRole}
                            UniqeID={this.props.UniqeID}
                            {...this.props}
                        />
                    </Tab>}
                    {this.props.role !='GManager' &&<Tab eventKey="dailySummary" title="Daily Summary">
                        <div>
                            <hr />
                        </div>
                        <DailyWalletSummary
                            selectedUserRole={this.props.selectedUserRole}
                            UniqeID={this.props.UniqeID}
                            {...this.props}
                        />
                    </Tab>}

                    {this.props.role !='GManager' &&<Tab eventKey="virtualAccounts" title="Virtual Accounts">
                        <div>
                            <hr />
                        </div>
                        <VirtualAccounts
                            selectedUserRole={this.props.selectedUserRole}
                            UniqeID={this.props.UniqeID}
                            {...this.props}
                        />
                    </Tab>}
                    

                    
                </Tabs>
            </Container>
        );
    }
}

export default ViewProfileDetail;
